'use strict';

angular.module('clientDashboardApp').directive('inlineConfirmation',function() {
  return {
    restrict: 'AE',
    scope: {
      updating: '=',
      success: '=',
      error: '=',
      customMsg: '='
    },
    controller: ($scope) => {
      $scope.defaultMsg = {
        updating : "Saving...",
        success : "Changes Saved",
        error : "Error"
      }
      $scope.mapStateToMsg = () => {
        let stateKey = ""
        if($scope.updating) {stateKey = "updating"}
        else if($scope.success) {stateKey = "success"}
        else if($scope.error) {stateKey = "error"}
        return $scope.customMsg ? $scope.customMsg[stateKey] : $scope.defaultMsg[stateKey]
      }
    },
    template: `<span ng-show="!updating && success">
    <fa class="fas" ng-class="{'text-success' : success, 'fa-check' : success, 'text-success' : error, 'fa-exclamation-circle' : error}"></fa>
     {{mapStateToMsg()}} </span>`
  }
});
